export class TypeSecuritySerializedModel {
    constructor(
        public UserId: number,
        public SelectedTypes: Array<number>) {
    }
}